// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"5689ca3c","147":"48198676","295":"dacc7b32","362":"88f030b5","510":"a245515c","574":"e53f911a","807":"91a49089","818":"737f2cf7","900":"cf3dd085","996":"d86a1d27"}[chunkId] + ".chunk.js";
};